import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import CanceledByOwnerTasksList from './CanceledByOwnerTasksList';

export default ColumnsContent(CanceledByOwnerTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/CanceledByOwnerTasksList/index.js